import { Reservation } from '@core/models';
import { useClientReservationStateObserver } from '@utils/reservation.util';
import React from 'react';

type Props = {
  reservation: Reservation<any>;
  children: React.ReactNode;
};

const ReservationStateObserver = ({ reservation, children }: Props) => {
  useClientReservationStateObserver(reservation);
  return <React.Fragment>{children}</React.Fragment>;
};

export default ReservationStateObserver;
